import React from "react";
import "./style.css"; // same css file for both sections

const TermsPage = () => {
  return (
    <>
      {/* ---------- Banner Section ---------- */}
      <section className="terms-banner">
        <div className="container">
          <h1 className="terms-heading">Terms Conditions</h1>

          <div className="breadcrumb">
            <span>Home</span>
            <span className="arrow">→</span>
            <span className="current">Terms Conditions</span>
          </div>
        </div>
      </section>

      {/* ---------- Content Section ---------- */}
      <section className="terms-content">
        <div className="container">
          <h2 className="tc-title">Terms & Conditions</h2>

          <p className="tc-text">
            These Terms of Service ("Terms", “Terms of Service”) govern your use
            of the Omeswara Services (together or individually “Service”) operated
            by OMESWARA FINTECH PRIVATE LIMITED (interchangeably “Company”,
            “we”, “our”, “us”, “Omeswara”, which shall, to the extent permitted by
            all Applicable Laws, include OMESWARA FINTECH PRIVATE LIMITED and
            its Group Companies, affiliates, partners, Service Providers,
            subsidiaries and parent company). Your agreement with us includes
            these Terms and our Privacy Policy (“Agreements”). You acknowledge that
            you have read and understood Agreements, and agree to be bound by them.
          </p>

          <p className="tc-text">
            These Terms and Conditions shall be effective and legally binding on
            the date when (a) Customer creates an Account, affirmatively accepts
            the Agreement in writing or electronically; or (b) otherwise uses the
            Services. Subsequently, these Terms and Conditions shall be continued
            until your termination of use of the Account or the Services. Your
            acceptance of these Terms and Conditions shall serve as confirmation
            that you fully understand and accept all the provisions in these Terms
            and Conditions. If you do not understand any of these Terms and
            Conditions, you are advised to obtain independent legal advice.
          </p>

          <h3 className="tc-subtitle">Definitions</h3>

          {/* ----------- Added Definitions Block ----------- */}
          <div className="tc-text-block">

            <p className="tc-text">
              “Currency” means the currency in which the Escrow Amount is denominated as per the Escrow Agreement.
            </p>

            <p className="tc-text">
              “Escrow Account” means the account maintained and operated by the Global Banking partner for the purpose of holding Escrow Amount.
            </p>

            <p className="tc-text">
              “Escrow Agreement” means an escrow agreement for the sale and purchase of Products & Services through Omeswara in accordance with the Escrow Terms and Conditions.
            </p>

            <p className="tc-text">
              “Escrow Amount” means the funds in the escrow account as per the Escrow Agreement.
            </p>

            <p className="tc-text">
              “Escrow Dispute” means any bilateral dispute arising in connection with a Transaction or Escrow Agreement between the Transacting or Escrow Parties.
            </p>

            <p className="tc-text">
              “Force Majeure” means events or causes including, but not limited to, the following: an act of God, peril of the sea,
              unavoidable accident of navigation, war (whether declared or not), sabotage, riot, insurrection, civil commotion,
              national emergency (whether in fact or law), martial law, fire, flood, cyclone, earthquake, landslide, explosion,
              power or water shortage, failure of a transmission or communication network, epidemic, quarantine, strike or other
              labour difficulty or expropriation, restriction, prohibition, law, regulation, decree or other legally enforceable
              order of a government agency, breakage or accident, change of International, State or Commonwealth law or regulation
              or any damage of Omeswara’s machinery or systems, unless occurring as a result of an act, omission, default or
              negligence of you or Omeswara.
            </p>

            <p className="tc-text">
              “Global Banking Partner” means a licensed provider of the payment services that Omeswara has contracted to obtain
              specific payment services including collecting, holding, disbursing, or remitting funds internationally.
            </p>

            <p className="tc-text">
              “Prohibited Industries” means the list of industries, as determined by Omeswara, that the Escrow parties should not be
              associated with to be able to use escrow service.
            </p>

            <p className="tc-text">
              “Prohibited Countries” means the list of countries that Omeswara does not allow the Product & Services to (a) originate
              from (b) pass through or (c) to be delivered in.
            </p>

            <p className="tc-text">
              “Proof of Shipment” means documents required as per the escrow agreement for fulfilling the terms of the agreement.
            </p>

            <p className="tc-text">
              “Third-Party Service Provider” means all types of service providers to the company, including Financial Partners and
              Global Banking Partners.
            </p>

            <p className="tc-text">
              “You” or “Your” means any person who enters into an Escrow Agreement.
            </p>

            <h3 className="tc-subtitle">General</h3>

            <p className="tc-text">
    The company owns and operates Omeswara (https://pg.Omeswara.com, https://Omeswara.com).
  </p>

  <p className="tc-text">
    You expressly employ, authorize, and instruct Omeswara to act as escrow agent in connection with each Escrow Agreement
    subject to Escrow terms & Conditions.
  </p>

  <p className="tc-text">
    You expressly employ Omeswara to act as a Service Provider for the purposes of collecting, holding, disbursing, or remitting
    the Escrow amount internationally.
  </p>

  <p className="tc-text">
    All communications shall be made in the English language.
  </p>

  <p className="tc-text">
    By using the Escrow service, you accept the escrow terms and conditions, and your intent and agreement to be bound by them.
  </p>

  <p className="tc-text">
    Omeswara engages third-party service providers from time to time to deliver its services. Terms and Conditions of the service
    providers are incorporated in Omeswara Terms and Conditions by reference. You will not interact directly with these service providers.
    Notwithstanding, by accepting the Omeswara Terms & Conditions, you agree that you are bound by the terms and conditions of the
    third-party service providers referred to in Omeswara Terms and Conditions.
  </p>

  <p className="tc-text">
    We do not and may in no situation be deemed to provide any tax or legal advice or approval or counsel with respect to Outbound
    Payment, their amount and timing, nor with respect to your relationship with a Payee nor a European Union Tax Administration
    nor your tax, legal or business status nor situation.
  </p>

  {/* ---------- KYC Verification ---------- */}
  <h3 className="tc-subtitle">KYC Verification</h3>

  <p className="tc-text">
    Your use of our Services is subject to Know Your Customer (“KYC”) and approval processes. We have the right to request information
    including, but not limited to, information on your identity, your business, and the shareholders of the business registering
    for an Account.
  </p>

  <p className="tc-text">
    You agree that the information provided by you to us is accurate, complete, and latest. Inaccurate, incomplete, or invalid
    information may lead to immediate termination of your account and services.
  </p>

  <p className="tc-text">
    You agree that we may take means to check and verify the information you provided, including using third-party intermediaries
    or databases, as necessary to validate your identity. Such means may include requests for additional information and documents
    prior to using or during the use of our Services, including, but not limited to, documents allowing us to verify the identity
    of you or your entity’s shareholders, proof of address or ownership, and additional business-related information or documents.
  </p>

  <p className="tc-text">
    We shall be entitled to deny your use or your continued use of the Services if you fail/refuse to provide the information
    requested by us under this Section.
  </p>

  {/* ---------- Next Subtitle Ready If Needed ---------- */}
  <h3 className="tc-subtitle">Escrow Agreement</h3>

   <p className="tc-text">
    Omeswara provides the Escrow Service to all registered users on the Omeswara Global portal.
  </p>

  <p className="tc-text">
    You are required to provide Escrow transaction information while creating an Escrow agreement as a document containing such
    information as (but not limited to).
  </p>

  <p className="tc-text">Details of the Products & Services.</p>

  <p className="tc-text">Details of the Escrow Parties.</p>

  <p className="tc-text">Details of the shipment and delivery of Products & Services.</p>

  <p className="tc-text">
    The conditions to be fulfilled for Omeswara to release the Escrow Amount to the seller.
  </p>

  <p className="tc-text">
    Countries where Products & Services (a) Originate from, or (b) will be delivered.
  </p>

  <p className="tc-text">
    Currency in which funds will be received and to be transferred.
  </p>

  <p className="tc-text">
    Omeswara prohibits the use of Escrow Service for (a) Prohibited Industries – Schedule A (b) Prohibited Countries – Schedule B,
    (c) illegal, unlawful, criminal, banned activities, or (d) violating any domestic and international laws or regulations.
  </p>

  {/* -------- Escrow Account -------- */}
  <h3 className="tc-subtitle">Escrow Account</h3>

  <p className="tc-text">
    The company has engaged global banking partners to provide Escrow payment service.
  </p>

  <p className="tc-text">
    Global banking partners operate and maintain Escrow Accounts & hold Escrow Amounts.
  </p>

  <p className="tc-text">
    Omeswara allows the opening of Escrow Accounts in US Dollars (USD), British Pound (GBP), EURO (EUR), and Singapore Dollars (SGD).
    We may, at any time at its sole discretion, enable or disable any currencies. Escrow Accounts denominated in these currencies
    are held with banks established Singapore.
  </p>

  {/* -------- Deposit of Funds -------- */}
  <h3 className="tc-subtitle">Deposit of funds</h3>

  <p className="tc-text">
    Omeswara will notify you on receipt of funds in your digital Escrow Account.
  </p>

  <p className="tc-text">
    There may be a time lag between the remitter’s deposit and when the escrow amount is reflected in the Escrow Account
    balance on the dashboard, due to inherent delay in Cross Border.
  </p>

  <p className="tc-text">
    Escrow Amount does not earn any interest.
  </p>

  {/* ---------- Transfer of Funds ---------- */}
  <h3 className="tc-subtitle">Transfer of funds</h3>

  <p className="tc-text">
    For transfer of funds, the seller must upload proof of shipment or other documentary proof as per the escrow agreement.
  </p>

  <p className="tc-text">
    The company has the right to ask you to provide an explanation, clarification, and information to verify the documents.
  </p>

  <p className="tc-text">
    You are solely responsible for the accuracy and validity of the information provided by you. Omeswara will process transactions
    based on the information provided by you and takes no liability whatsoever for erroneous credits to beneficiaries.
  </p>

  <p className="tc-text">
    Fund transfer will be processed on the same day if the transfer has been initiated on or before the cut-off time of 10.30 AM IST.
  </p>

  <p className="tc-text">
    You shall ensure that your Beneficiary Account information is true, accurate, and complete. We shall in no event be held
    responsible for funds being sent to the wrong bank account as a result of your provision of untrue, inaccurate, or incomplete
    Beneficiary Account information.
  </p>

  <p className="tc-text">
    In the event that the payment is rejected due to untrue, inaccurate, or incomplete Beneficiary Account information provided by
    you, you shall solely be responsible for relevant Fees and we may directly deduct such Fees from your Balance.
  </p>

  <p className="tc-text">
    In case of any incorrect or misdirected payment, we shall take reasonable measures to assist you with tracing and, if reasonably
    feasible, recovering such payments, but we shall in no event be liable for any payments that cannot be recovered. All our additional
    costs in relation thereto shall be borne by you.
  </p>

  <p className="tc-text">
    You shall ensure that your Beneficiary Account is in good standing and able to receive Funds. If your Beneficiary Account bank
    rejects the fund transfer from us, Funds will be held with us until a valid Beneficiary Account is provided. All costs associated
    thereto shall be borne by you.
  </p>

  <p className="tc-text">
    Omeswara shall be entitled to reject any Beneficiary Accounts that do not comply with Omeswara’s compliance requirements and/or if
    payments to such Beneficiary Account would violate Applicable Laws. You shall provide another Beneficiary Account so that we can
    continue to provide the Services to you.
  </p>

  <p className="tc-text">
    Omeswara may refuse to execute an Outbound Payment Order in case of a technical issue or if the information provided by the
    Customer is untrue, inaccurate, or incomplete.
  </p>

  <p className="tc-text">
    After receiving the fund transfer instruction, we will initiate a fund transfer request in the amount and currency you selected.
    Any Fees charged by the bank of your Beneficiary Account shall be your sole responsibility and we shall not be liable for such fees.
  </p>

  <p className="tc-text">
    Where Beneficiary currency is different from sender’s currency, the transfer to the beneficiary is subject to currency conversion.
  </p>

  <p className="tc-text">
    From time to time, we will identify on the Website the currencies for which the Service is available. Available currencies are
    subject to change at our sole discretion.
  </p>

  <p className="tc-text">
    You agree not to use the Services for any unlawful activity and Omeswara reserves the right to investigate any suspicious activity
    or in response to any complaints or reported violations. When investigating any such activity, Omeswara reserves the right to
    report suspected unlawful activity to any appropriate person or body and to provide them with any relevant information,
    including personal data.
  </p>


  {/* ---------- Dispute Section ---------- */}
  <h3 className="tc-subtitle">Dispute</h3>

  <p className="tc-text">
    Any dispute between the Users in relation to a transaction is between the Users. Omeswara will not get involved beyond its
    obligations under the Trade. Omeswara may offer assistance or facilitate the resolution of a dispute between Users if a dispute
    between Users arises but is under no obligation to do so. The Parties hereby agree to use their best efforts to negotiate
    in good faith during the dispute to reach a resolution that is satisfactory for all parties.
  </p>

  <p className="tc-text">
    In case of dispute, Omeswara will hold the funds in the Escrow Account.
  </p>

  <p className="tc-text">
    Till parties resolve the dispute and confirm to Omeswara, Confirmation of both buyer and seller is required for the final release
    of the funds or
  </p>

  <p className="tc-text">It receives an order from an arbitrator or</p>

  <p className="tc-text">
    It receives an order from an appropriate court of law or similar legal body.
  </p>

  <p className="tc-text">
    Confirmation of both buyer and seller is required for the final release of the funds.
  </p>

  <p className="tc-text">
    Omeswara will disburse the funds as per confirmation by both the parties.
  </p>

  <p className="tc-text">
    In case of dispute between the Parties, the Escrow Agent will hold the funds in the Escrow Account till the dispute is resolved
    and written confirmation from authorized officials is provided to Omeswara by Parties either in writing or by sending an email at
    hello@Omeswara.com.
  </p>
   {/* ---------- Escrow Fees ---------- */}
  <h3 className="tc-subtitle">Escrow Fees</h3>

  <p className="tc-text">
    Omeswara shall advise you of all Fees that may be charged by us for use of the Escrow Account. Acting reasonably,
    and the following notice to you, we may from time to time adjust existing Fees or introduce new Fees.
  </p>

  <p className="tc-text">
    You shall pay all fees from time to time adjusted by us and your continued use of the Omeswara Services indicates your
    continued acceptance of the Fees. When we adjust our Fees, we will send you an email notification (if required).
    If you have any questions or are unclear as to any Fees, you should contact our Customer Support.
  </p>


  {/* ---------- Liabilities & Indemnification ---------- */}
  <h3 className="tc-subtitle">Liabilities & Indemnification</h3>

  <p className="tc-text">
    You agree that you solely bear all risks from your use of the Escrow service without any recourse whatsoever to the company.
  </p>

  <p className="tc-text">
    You shall indemnify, defend, save and hold harmless the company, its relevant person, and affiliates from losses and claims
    due to your violation of the Escrow Terms and Conditions.
  </p>

  <p className="tc-text">
    If we are unable to perform our obligations under this Agreement because of factors beyond our control, including a change 
    of law, an event of Force Majeure, withdrawal of a currency or the imposition of sanctions over a country or beneficiary,
    we will notify you as soon as is reasonably practicable and will use reasonable endeavours to secure the return of any money 
    paid by you in respect of which we have been unable to discharge our obligations under this Agreement. We will not have any 
    liability to you where we are unable to perform our obligations.
  </p>

  <p className="tc-text">
    You shall solely be responsible for reporting to all applicable government tax authorities all Funds underlying your use of the
    Services and for the payment of any applicable taxes that apply to such payments as well as any other applicable reporting
    requirements including, but not limited to, any customs or foreign currency controls.
  </p>

  <p className="tc-text">
    We may request you to provide proof of payment of taxes as and when it considers necessary and appropriate.
  </p>

  <p className="tc-text">
    Omeswara shall not be liable to you or any third party for any loss, damage, claim or compensation (including loss of profit
    or loss of use) incurred by you resulting from the failure or delay of Omeswara to execute any transfer in accordance with the
    instructions from you.
  </p>

  <p className="tc-text">
    Omeswara shall not be liable for any fees or commissions charged by any intermediary bank or other entity when funds are 
    deposited in your account or transferred to your personal or your receiver’s account.
  </p>


  {/* ---------- Protection of Data ---------- */}
  <h3 className="tc-subtitle">Protection of Data</h3>

  <p className="tc-text">
    We will ensure that all your personal information is held in accordance with the data privacy and security provisions of 
    Applicable Law and our published Privacy Policy.
  </p>

  <p className="tc-text">
    Your use of the Services is subject to the Privacy Policy which you agree to as part of these Terms and Conditions. 
    Please make yourself familiar with the Privacy Policy by visiting it on our website.
  </p>

  <p className="tc-text">
    Omeswara in its sole discretion may amend the Privacy Policy by an update on the Privacy Policy page of the website. 
    You may review the Privacy Policy at any time by clicking on the Privacy Policy on the website.
  </p>

  <p className="tc-text" style={{ fontWeight: "600", textTransform: "uppercase" }}>
    YOU ACKNOWLEDGE AND AGREE THAT Omeswara RESERVES THE RIGHT TO ACCESS AND DISCLOSE PERSONAL DATA RELATING TO YOU TO 
    THIRD PARTIES TO COMPLY WITH ALL APPLICABLE LAWS AND LAWFUL REQUESTS FROM GOVERNMENT AND/OR OTHER REGULATORY AUTHORITIES,
    AND/OR TO PROVIDE SERVICES OF Omeswara OR PROTECT Omeswara, ITS CUSTOMERS, AND OTHER USERS.
  </p>


  {/* ---------- Laws and Jurisdiction ---------- */}
  <h3 className="tc-subtitle">Laws and Jurisdiction</h3>

  <p className="tc-text">
    The provision of the Service and any dispute or claim arising out of the provision of the Service is governed by Singapore law.
    Any dispute or claim arising out of or in connection with the Service will be subject to the exclusive jurisdiction of the
    courts of Singapore.
  </p>


  {/* ---------- Acknowledgment ---------- */}
  <h3 className="tc-subtitle">Acknowledgment</h3>

  <p className="tc-text">
    By using service or other services provided by us, you acknowledge that you have read these terms of service and agree to be 
    bound by them.
  </p>


  {/* ---------- Prohibited Industries — Schedule A ---------- */}
  <h3 className="tc-subtitle">Prohibited Industries — Schedule A</h3>

  <p className="tc-text">
    Following merchant categories/industries are prohibited by Omeswara for onboarding.
  </p>

  <p className="tc-text">Weapons, ammunition, military arms, explosive devices, and firearm parts</p>
  <p className="tc-text">Adult entertainment</p>
  <p className="tc-text">Gambling including digital and physical establishments (casinos)</p>
  <p className="tc-text">Multi-level marketing, Ponzi, or pyramid schemes</p>
  <p className="tc-text">
    Production, sale, trading, or servicing of illegal goods/services including but not limited to stolen/ counterfeit 
    goods/trademark infringement, human trafficking, child labour, prostitution, illegal drugs etc.
  </p>


  {/* ---------- Prohibited Countries — Schedule B ---------- */}
  <h3 className="tc-subtitle">Prohibited Countries — Schedule B</h3>

  <p className="tc-text">
    Following countries are prohibited by Omeswara for all transactions
  </p>

  <p className="tc-text">
    Belarus, Crimea, Cuba, Ukraine, Iran, Libya, N Korea, Russia, Sudan, Syria, Venezuela
  </p>


          </div>
        </div>
      </section>
    </>
  );
};

export default TermsPage;
